<!--  -->
<template>
  <div>
      <section class="footer-area">
        <div class="ocean">
            <div class="wave"></div>
            <div class="wave"></div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-sm-6">
                    <div class="footer-widget">
                            <h3 class="footer-title">声明</h3>
                            <span class="section__divider"></span>
                            <ul class="footer-link">
                                <li>版权与免责声明</li>
                                <li>防盗链声明</li>
                            </ul>
                        </div><!-- end footer-widget -->
                </div><!-- end col-lg-3 -->
                <div class="col-lg-3 col-sm-6">
                        <div class="footer-widget">
                            <h3 class="footer-title">联系我们</h3>
                            <span class="section__divider"></span>
                            <ul class="footer-link">
                                <li>{{webConfig.name}}</li>
                                <li>{{webConfig.address}}</li>
                                <li>电话：{{webConfig.mobile}}</li>
                                <li>邮箱：{{webConfig.mail}}</li>
                            </ul>
                        </div><!-- end footer-widget -->
                    </div><!-- end col-lg-3 -->
                    <div class="col-lg-3 col-sm-6">
                        <div class="footer-widget">
                            <h3 class="footer-title">关于我们</h3>
                            <span class="section__divider"></span>
                            <ul class="footer-link">
                                <li><a href="#">企业官网</a></li>
                                <li><a href="#">意见反馈</a></li>
                            </ul>
                        </div><!-- end footer-widget -->
                    </div><!-- end col-lg-3 -->
                    <div class="col-lg-3 col-sm-6">
                        <div class="footer-widget">
                            <img src="/static/images/recode.png" />
                            <p>手机版</p>
                        </div><!-- end footer-widget -->
                    </div>
            </div><!-- end row -->
            
        </div><!-- end container -->
        <div class="lightline"></div>
        <p class="copy__desc">Copyright © 2022 www.cnks.org.cn <a href="http://beian.miit.gov.cn/" style="color:#fff;" target="_blank">京ICP备18062373号-6</a></p>
    </section><!-- end footer-area -->
  </div>
</template>

<script>
export default {
  data () {
    return {
        webConfig:{},

    };
  },

  components: {},

  computed: {},

  mounted(){
      this.$axios.get("/api/webConfigs").then(res => {
        if(res.data&&res.data.data.length>0)
        {
            this.webConfig = res.data.data[0];
        }
    }); 
  },

  methods: {}
}

</script>
<style scoped>
.footer-area{
    width: 100%;
    height: 324px;
    background: #4282CA;
    margin-top: 25px;
}
.footer-link{
     font-size: 14px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 28px;
}
.footer-link a{
    width: 190px;
    height: 99px;
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 28px;
    }
.footer-title{
    margin: 40px 0 25px 0;
    width: 85px;
    height: 19px;
    font-size: 20px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 28px;
}
.footer-widget img{
    margin: 40px 0 9px 0;
    width: 127px;
    height: 127px;
    background: #FFFFFF;
}
.footer-widget p{
     width: 127px;
    text-align: center;
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 28px;
}
.lightline{
    width: 1920px;
height: 1px;
background: #EEEEEE;
opacity: 0.43;
position: relative;
       bottom: -64px;
}
.copy__desc{
text-align: center;
    width: 100%;
    height: 54px;
    font-size: 12px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 54px;
    position: relative;
    bottom: -65px;
}
</style>